import React from 'react';

interface LocaleContextValue {
  locale: string | undefined;
  setLocale: (locale: string) => void;
}

const LocaleContext = React.createContext<LocaleContextValue>({
  locale: undefined,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setLocale: () => {},
});

export default LocaleContext;
